import { ValidationBoxProps } from "./types";

const ValidationBox = ({ children }: ValidationBoxProps) => (
  <div className="flex items-center min-h-12 border-l-4 border-l-red mt-2 py-2 pl-4 pr-5 bg-greyBackground dark:bg-gray-700 w-full shadow-lg shadow-greyShadow transition-all duration-450 dark:shadow-gray-600">
    {children}
  </div>
);

export default ValidationBox;
